import * as React from 'react';
import { useEffect, useState } from 'react';
import { ConceptInput, MemberConceptInput, ConceptLabelInput, RelationshipInput, addRelationshipChange, addConceptChange, addMemberConceptChange, getLabelValue } from '../../../redux/TaxonomyChangesSlice';
import { useAppSelector, useAppDispatch } from '../../../hooks/index';
import { FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Select from 'react-select';
import { setIsTaxonomyDirty } from '../../../redux/TaxonomyVersionSlice';
import { Concept } from '../../../redux/ConceptSlice';
import { Edit } from '../../../redux/MiscSlice';
import enums from '../../../utils/enums';
import utilityHelper from '../../../utils/utilityHelper';
import { ConceptNode, populateAccountCodeMap } from '../../../redux/AccountsSlice';


import './ModalPopUp.css';
import Modal from './Modal';
//import { statSync } from 'node:fs';

interface ConceptLabel {
    roleName: string,
    value: string;
}
interface ddTypeOption {
    label: string;
    value: string;
    isDisabled: boolean;
}
interface iProcessCode
{
    userConceptCode: string;
    codeRole: string;
}

export interface CreateConceptProps {
    parentName: string;
    parentCode: string;
    parentRelationship: RelationshipInput;
    conceptType: string;
    codeValidator: (value: string) => boolean;
    onCloseModal: (event : any) => void;
    isOpen: boolean;
    isMemberConcept: boolean;
    accountTree: ConceptNode[];
    conceptChanges: ConceptInput[];

}

function CreateConceptModal(props: CreateConceptProps) {

    const dispatch = useAppDispatch();

    const [isAbstract, setIsAbstract] = useState("no");
    const [conceptId, setConceptId] = useState("");
    const [conceptCode, setConceptCode] = useState("");
    const [conceptLabel, setConceptLabel] = useState("");

    const getDefaultDataType = function() : string {
        if (props.isMemberConcept === true) {
            return "DTR_TYPES_DOMAINITEMTYPE";
        } else {
            return "XBRLI_MONETARYITEMTYPE";
        }
    }
    const [conceptDatatype, setConceptDatatype] = useState(getDefaultDataType());
    const [conceptPeriodtype, setConceptPeriodtype] = useState("duration");
    const [conceptBalancetype, setConceptBalancetype] = useState("credit");
    const [accountCodeMap, setAccountCodeMap] = useState({});

    const getCodeRange = function (pcode: String) : string {
        var idx = pcode.indexOf("x");
        if (idx < 0) {
            return "";
        }
        var prefix = pcode.substring(0, idx);
        var varcode = pcode.substring(idx);
        return "Code must be unique within scope of parent codes";
    }
    const [codeRange, setCodeRange] = useState(getCodeRange(props.parentCode));

    const getDatatypes = function (allTypes: any): ddTypeOption[] {
        var options: ddTypeOption[] = [];
        if (!allTypes) {
            return options;
        }

        Object.keys(allTypes).map(function (key) {
            var optName = allTypes[key];
            var option: ddTypeOption = {
                label: optName,
                value: key,
                isDisabled: false
            }
            options.push(option);
        });
        options.sort((a, b) => a.label.localeCompare(b.label));
        return options;
    }
    const [dataTypes, setDataTypes] = useState<ddTypeOption[]>(getDatatypes(enums.conceptCreationDatatype));
    const [selectedOption, setSelectedOption] = useState<ddTypeOption>({ label: "", value: "", isDisabled: false });

    const getCodePrefix = function () : string {
        var pid = props.parentRelationship ? props.parentRelationship.fromId : "";
        var idx = pid.indexOf("_");
        var prefix = (idx < 1) ? "" : pid.substring(0, idx + 1); // If we're grabbing the parent prefix include the '_'
        return prefix;
    }
    const updateId = function (prefix : string, label: string, code: string) {
        var result = prefix;
        switch (prefix) {
            case "BS_":
            case "Rev_":
            case "Exp_":
                result += code + "_";
                // By convention the code is the first part of the label
                // We strip out that duplication when creating the id from the code + label
                label = label.replace(code + " - ", "");
                break;
        }
        setConceptId(utilityHelper.removeNonTokenCharacters(result + label));
    }

    const infoChanged = function (info: string, value: string) {
        var prefix: string = getCodePrefix();
        switch (info) {
            case "label":
                setConceptLabel(value);
                updateId(prefix, value, conceptCode);
                break;
            case "code":
                var codeValue = value;
                switch (prefix) {
                    case "BS_":
                    case "Rev_":
                    case "Exp_":
                        // Limit the numeric restriction of code values to accounts in the UAS tree
                        codeValue = utilityHelper.removeNonAccountCodeCharacters(value);
                        break;
                }
                setConceptCode(codeValue);
                updateId(prefix, conceptLabel, codeValue);
                break;
        }
    }
    // Handle Event
    const handleTypeChange = (e: any, action: any) => {
        setConceptDatatype(e.value);

    }

    const handleAbstractChange = (e: any) => {
        setIsAbstract(e.target.value);
    }

    const handlePeriodChange = (e: any) => {
        setConceptPeriodtype(e.target.value);
    }

    const handleBalanceChange = (e: any) => {
        setConceptBalancetype(e.target.value);
    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "conceptLabel":
                if (!conceptLabel || conceptLabel.length === 0) {
                    result = false;
                }
                break;
            case "code":
                if (!conceptCode || conceptCode.length === 0) {
                    result = false;
                }
                var codeInfo = processCode(conceptCode);
                if (accountCodeMap && accountCodeMap.hasOwnProperty(codeInfo.userConceptCode)) {
                    return false;
                }
                break;
        }
        return result;
    }

    const anyNotValid = function (): boolean {
        if (!isValid("conceptLabel") || !isValid("code")) {
            return true;
        }
        if (props.isMemberConcept === true) {
            return false; // nothing more that can be invalid, the rest of the attributes are predetermined for member concepts.
        }
        if (conceptDatatype.length == 0) {
            return true;
        }
        return false;
    }
 
    const setTaxonomyDirty = function () {
        var estate: Edit = {
            IsDirty: true,
            Page: ""
        }
        dispatch(setIsTaxonomyDirty(estate));
    }
    const processCode = function (conceptCode: string): iProcessCode {
        // Be prepared to automatically prefix the code
        var codeRole = "code";
        var userConceptCode = conceptCode;
        switch (props.parentRelationship.networkId.toLowerCase()) {
            case "reporting-units":
                codeRole = "RepUnitCode";
                console.log("ctype", props.parentName, props.conceptType);
                if (props.conceptType === "district type") {
                    switch (props.parentName) {
                        case "OtherEntity":
                            userConceptCode = "OE_" + userConceptCode;
                            break;
                        case "SpecialDistrict":
                            userConceptCode = "SD_" + userConceptCode;
                            console.log("cc", userConceptCode);
                            break;
                    }
                }
                break;
            default:
                codeRole = "AccountCode";
                break;
        }
        return { userConceptCode: userConceptCode, codeRole: codeRole };
    }
    // browse the and save temporarily in redux store
    const handleCreateConcept = (e: any) => {
        var labels: ConceptLabelInput[] = [];
        labels.push({ conceptId: conceptId, role: "label", value: conceptLabel });
        var codeInfo: iProcessCode = processCode(conceptCode);
        var codeRole = codeInfo.codeRole;
        var userConceptCode = codeInfo.userConceptCode;
        labels.push({ conceptId: conceptId, role: codeRole, value: userConceptCode });
        if (props.isMemberConcept === true) {
            var memConcept = {
                id: conceptId,
                labels: labels
            };
            dispatch(addMemberConceptChange(memConcept));
        } else {
            var concept: ConceptInput = {
                id: conceptId,
                labels: labels,
                isAbstract: (isAbstract === "yes"),
                isCredit: (conceptBalancetype === "credit"),
                datatype: conceptDatatype,
                periodtype: conceptPeriodtype
            };
            dispatch(addConceptChange(concept));
        }
        if (props.parentRelationship) {
            // we are supplied with the parent relationship if we create an new concept
            var addRel: RelationshipInput = { ...props.parentRelationship, toId: conceptId };
            dispatch(addRelationshipChange(addRel))
        }
        var newLabels: ConceptLabel[] = [];
        labels.map(lab => newLabels.push({
            roleName: lab.role,
            value: lab.value ? lab.value : ""
        }));
        var newConcept: Concept = {
            name: conceptLabel,
            code: userConceptCode,
            id: conceptId,
            documentation: "",
            datatype: conceptDatatype,
            domainDatatype: "",
            labels: newLabels,
            references: [],
            deprecation: null,
            isAbstract: (isAbstract === "yes"),
            isCredit: (conceptBalancetype === "credit"),
            periodtype: conceptPeriodtype,
            isDeprecated: false
        }
        //close modal
        props.onCloseModal({ newid: conceptId, newconcept: newConcept });

    }

    const leftMarginStyle = {
        marginLeft: '1em'
    }

    //    const renderPage = generateDropdownValues(false)
    useEffect(() => {
        var accMap : any = {};
        if (!(props.accountTree == null)) {
            populateAccountCodeMap(props.accountTree, accMap);
            if (!(props.conceptChanges == null)) {
                for (var cc of props.conceptChanges) {
                    var ccCode: string = getLabelValue(cc, "code", "no code");
                    var ccName: string = getLabelValue(cc, "label", "no label");
                    props.conceptChanges.map(cc => accMap[ccCode] = ccName);
                }
            }
        }
        setAccountCodeMap(accMap);
        setIsAbstract("no");
        setConceptCode("");
        setConceptLabel("");
        setConceptDatatype(getDefaultDataType());
        setConceptPeriodtype("duration");
        setConceptBalancetype("credit");
        updateId("", "", "");
    }, [props]);


    return (
        <React.Fragment >
            <Modal isOpen={props.isOpen} onClose={props.onCloseModal}>
                <div className="ModalPopUp">
                    <h4>Creating new {props.conceptType}</h4>
                    <br />
                    <br />
                    <Row style={{ width: "100%" }}>
                        <Col >
                            <FormGroup>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Parent:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Label><b>{props.parentName}</b></Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>ID:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Label><b>{conceptId}</b></Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Standard Label:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="text" value={conceptLabel}
                                            onChange={(e) => infoChanged("label", e.currentTarget.value)}
                                            valid={isValid("conceptLabel")}
                                            invalid={(!isValid("conceptLabel"))} />
                                        <FormFeedback>Label is required.</FormFeedback>
                                    </Col>
                                </Row>

                            </FormGroup>
                           <FormGroup>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Code:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="text" value={conceptCode}
                                            onChange={(e) => infoChanged("code", e.currentTarget.value)}
                                            valid={isValid("code")}
                                            invalid={(!isValid("code"))} />
                                        <FormFeedback>Code is required and must be unique. {codeRange}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>
                            {props.isMemberConcept === false
                                ?
                                <div>
                                    <FormGroup>
                                        <Row>
                                            <Col className="text-md-right" >
                                                <Label><b>Datatype:</b></Label>
                                            </Col>
                                            <Col md="9">
                                                <Select
                                                    name={'ConceptDataTypes'}
                                                    onChange={handleTypeChange}
                                                    autoFocus
                                                    options={dataTypes}
                                                    defaultValue={dataTypes.find(dt => dt.label === "money")}
                                                    isOptionDisabled={(option: any) => option.isdisabled}
                                                    style={{ width: "25em" }}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col className="text-md-right" >
                                                <Label><b>Abstract:</b></Label>
                                            </Col>
                                            <Col md="9">
                                                <Row>
                                                    <Label className="ml-4" check>
                                                        <Input type="radio"
                                                            name="radioAbstract"
                                                            value={"yes"}
                                                            onChange={handleAbstractChange}
                                                            checked={(isAbstract === "yes")}
                                                        /><b>Yes</b>
                                                    </Label>
                                                    <Label className="ml-5" check>
                                                        <Input type="radio"
                                                            value={"no"}
                                                            name="radioAbstract"
                                                            onChange={handleAbstractChange}
                                                            checked={(isAbstract === "no")}
                                                        /><b>No</b>
                                                    </Label>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col className="text-md-right" >
                                                <Label><b>Period:</b></Label>
                                            </Col>
                                            <Col md="9">
                                                <Row>
                                                    <Label className="ml-4" check>
                                                        <Input type="radio"
                                                            name="radioPeriod"
                                                            value={"duration"}
                                                            onChange={handlePeriodChange}
                                                            checked={(conceptPeriodtype === "duration")}
                                                        /><b>Duration</b>
                                                    </Label>
                                                    <Label className="ml-5" style={leftMarginStyle} check>
                                                        <Input type="radio"
                                                            value={"instant"}
                                                            name="radioPeriod"
                                                            onChange={handlePeriodChange}
                                                            checked={(conceptPeriodtype === "instant")}
                                                        /><b>Instant</b>
                                                    </Label>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col className="text-md-right" >
                                                <Label><b>Balance:</b></Label>
                                            </Col>
                                            <Col md="9">
                                                <Row>
                                                    <Label className="ml-4" check>
                                                        <Input type="radio"
                                                            name="radioBalance"
                                                            value={"credit"}
                                                            onChange={handleBalanceChange}
                                                            checked={(conceptBalancetype === "credit")}
                                                        /><b>Credit</b>
                                                    </Label>
                                                    <Label className="ml-5" style={leftMarginStyle} check>
                                                        <Input type="radio"
                                                            value={"debit"}
                                                            name="radioBalance"
                                                            onChange={handleBalanceChange}
                                                            checked={(conceptBalancetype === "debit")}
                                                        /><b>Debit</b>
                                                    </Label>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </div>
                                : <div></div>
                            }
                        </Col>

                    </Row>
                    <div>
                        <button disabled={anyNotValid()} onClick={handleCreateConcept} className="btn btn-primary mr-4">
                            Create {props.conceptType}
                        </button>
                        <button onClick={props.onCloseModal} className="btn btn-primary">
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default CreateConceptModal;